import type { ChatClient } from '@wtfalch/chat';
import { useEffect, useState } from 'react';

import { shortName } from './format.ts';

/**
 * Who is typing in `roomId`, other than the signed-in person, by name --
 * `onTypingChanged` already excludes them (its own doc), so nothing here
 * filters again. Resubscribes, and starts from empty, on every room switch:
 * `m.typing` is never replayed on subscribing (`onPresenceChanged`'s own
 * sibling doc says the same of presence), so a stale name from the room just
 * left must not linger into the one just opened.
 */
export function useTypingNames(client: ChatClient, roomId: string): string[] {
  const [userIds, setUserIds] = useState<readonly string[]>([]);

  useEffect(() => {
    setUserIds([]);
    return client.onTypingChanged(roomId, setUserIds);
  }, [client, roomId]);

  const members = client.roomMembers(roomId);
  return userIds.map((id) => shortName(members.find((m) => m.userId === id)?.name ?? id));
}
